import React from 'react'
import { Modal, Button } from 'react-bootstrap'

/**
 * DeleteCourtModal - Confirmation modal for deleting a court
 *
 * Props:
 * - show: boolean - controls modal visibility
 * - onHide: function - called when modal is closed
 * - onConfirm: function - called when deletion is confirmed
 * - court: object | null - court to be deleted
 * - isProcessing: boolean - shows loading state during API call
 */
export default function DeleteCourtModal({
  show,
  onHide,
  onConfirm,
  court = null,
  isProcessing = false,
}) {
  if (!court) return null

  const courtAddress = [court.address_line1, court.city, court.state, court.zip]
    .filter(Boolean)
    .join(', ')

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={isProcessing ? 'static' : true}
    >
      <Modal.Header closeButton={!isProcessing}>
        <Modal.Title>Delete Court</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete <strong>{court.name}</strong>?
        </p>
        {courtAddress && (
          <p className="text-muted small mb-0">{courtAddress}</p>
        )}
        <div className="alert alert-warning mt-3 mb-0">
          <strong>Warning:</strong> This action cannot be undone. The court will
          be permanently deleted from the system.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isProcessing}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isProcessing}>
          {isProcessing ? 'Deleting...' : 'Delete Court'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
